const WORKFLOW_RUN_STORAGE_PREFIX = 'galexia-workflow-run';

function getWorkflowRunStorageKey(sessionId: string) {
  return `${WORKFLOW_RUN_STORAGE_PREFIX}:${sessionId}`;
}

export function getStoredWorkflowRunId(sessionId: string | null | undefined) {
  if (!sessionId || typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem(getWorkflowRunStorageKey(sessionId));
}

export function setStoredWorkflowRunId(sessionId: string | null | undefined, runId: string) {
  if (!sessionId || typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(getWorkflowRunStorageKey(sessionId), runId);
}

export function clearStoredWorkflowRunId(sessionId: string | null | undefined) {
  if (!sessionId || typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(getWorkflowRunStorageKey(sessionId));
}
